'use strict';

var primaryColor = '#660066';

module.exports = primaryColor;